import { defineMessages } from "react-intl";
export default defineMessages({
    newReportLayoutBackToHome: {
        id: "aiDiscoverability.newReportLayout.backToHome",
        defaultMessage: "Back to Home",
    },
    newReportLayoutHelp: {
        id: "aiDiscoverability.newReportLayout.help",
        defaultMessage: "Help",
    },
    newReportLayoutNext: {
        id: "aiDiscoverability.newReportLayout.next",
        defaultMessage: "Next",
    },
});
